import {Flow} from "@ampeco/charge-flow";

export default class RequirementsForUsageFlow extends Flow {
    protected collectSteps() {
        console.log('collecting steps for RequirementsForUsageFlow');
    }
}
